import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQITSection = () => <FAQSectionI18n translationPrefix="industryIT" bgClass="bg-secondary/30" />;
export default FAQITSection;
